import { useLoad } from "@allergy123/api-client/react";
import { Card, Status, Table, Td, Th } from "@allergy123/ui";
import { Link, useSearchParams } from "react-router";
import { CatalogHeader, errorText } from "./common";

export function PanelComparePage() {
  const [params] = useSearchParams();
  const a = params.get("a") ?? "";
  const b = params.get("b") ?? "";
  const data = useLoad((api) => api.admin.catalog.comparePanels(a, b), [a, b]);
  const cmp = data.data;
  return (
    <>
      <CatalogHeader title="Compare tray panels" intro="Wells that differ between two versions or two panels." />
      {data.state === "error" && <div className="mb-6"><Status kind="error" label={`Couldn't compare (${errorText(data.error)})`} /></div>}
      {data.state === "loading" && <p className="text-ink-secondary">Loading…</p>}
      {cmp && (
        <Card>
          <p className="mb-4 flex flex-wrap gap-4 text-small">
            <Link to={`/catalog/panels/versions/${cmp.a.id}`} className="text-anchor underline">Open {cmp.a.family.code} v{cmp.a.version}</Link>
            <Link to={`/catalog/panels/versions/${cmp.b.id}`} className="text-anchor underline">Open {cmp.b.family.code} v{cmp.b.version}</Link>
          </p>
          <Table caption={`${cmp.a.family.code} v${cmp.a.version} → ${cmp.b.family.code} v${cmp.b.version}: ${cmp.differences.length} well(s) differ`}>
            <thead>
              <tr>
                <Th>Position</Th>
                <Th>{cmp.a.family.code} v{cmp.a.version}</Th>
                <Th>{cmp.b.family.code} v{cmp.b.version}</Th>
              </tr>
            </thead>
            <tbody>
              {cmp.differences.map((d) => (
                <tr key={d.position}>
                  <Td>{d.position}</Td>
                  <Td>{d.a ? `${d.a.trayLabel} · ${d.a.displayName}${d.a.fillSource === "mix_recipe" ? " (mix)" : ""}` : "empty"}</Td>
                  <Td>{d.b ? `${d.b.trayLabel} · ${d.b.displayName}${d.b.fillSource === "mix_recipe" ? " (mix)" : ""}` : "empty"}</Td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      )}
    </>
  );
}
